<template>
  <div class="cultural-content">
    <div class="content-title">
      <div class="title-left">
        {{ lan ? showData.culturalEnTitle : showData.culturalCnTitle }}
      </div>
      <div
        class="title-right-btn"
        v-if="!isIndex && showData.imgList.length > 4"
      >
        <img
          class="leftArr"
          @click="toLeft"
          v-if="toLeftFlag"
          src="../../assets/rightArr_black.png"
          alt=""
        />
        <img
          class="leftArr"
          @click="toLeft"
          v-if="!toLeftFlag"
          src="../../assets/rightArr_gery.png"
          alt=""
        />
        <img
          class="rightArr"
          @click="toRight"
          v-if="toRightFlag"
          src="../../assets/rightArr_black.png"
          alt=""
        />
        <img
          class="rightArr"
          @click="toRight"
          v-if="!toRightFlag"
          src="../../assets/rightArr_gery.png"
          alt=""
        />
      </div>
      <div
        class="title-right-btn"
        v-else-if="isIndex && showData.imgList.length > 2"
      >
        <img
          class="leftArr"
          @click="toWapLeft"
          v-if="toLeftFlag"
          src="../../assets/rightArr_black.png"
          alt=""
        />
        <img
          class="leftArr"
          v-if="!toLeftFlag"
          src="../../assets/rightArr_gery.png"
          alt=""
        />
        <img
          class="rightArr"
          @click="toWapRight"
          v-if="toRightFlag"
          src="../../assets/rightArr_black.png"
          alt=""
        />
        <img
          class="rightArr"
          v-if="!toRightFlag"
          src="../../assets/rightArr_gery.png"
          alt=""
        />
      </div>
    </div>
    <div class="cultural-content-info" :id="`cultural${showNumber}`">
      <div
        class="cultural-item"
        v-for="(item, index) in showData.imgList"
        :key="index"
      >
        <img :src="item.src" alt="" />
        <div class="cultural-title">{{ item.title }}</div>
        <div class="cultural-money">{{ item.label || 0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showData: {
      type: Object,
      default: () => ({}), // 修正为返回空对象，但在此示例中未使用
    },
    showNumber: {
      type: Number,
      default: 1, // 修正为返回空对象，但在此示例中未使用
    },
  },
  data() {
    return {
      isIndex: false,
      toLeftFlag: false,
      toRightFlag: true,
      screenWidth: null,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    this.screenWidth = Number(screenWidth);
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  mounted() {
    // 初始化时检查一次边界
    this.$nextTick(() => {
      this.updateScrollButtons();
    });
    
    // 监听滚动事件更新按钮状态
    const container = document.getElementById(`cultural${this.showNumber}`);
    if(container) {
      container.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    const container = document.getElementById(`cultural${this.showNumber}`);
    if(container) {
      container.removeEventListener('scroll', this.handleScroll);
    }
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleScroll() {
      this.updateScrollButtons();
    },
    updateScrollButtons() {
      const container = document.getElementById(`cultural${this.showNumber}`);
      if(!container) return;
      
      const { scrollLeft, scrollWidth, clientWidth } = container;
      // 更新左箭头状态（如果不在最左边则可点击）
      this.toLeftFlag = scrollLeft > 0;
      // 更新右箭头状态（如果不在最右边则可点击）
      this.toRightFlag = scrollLeft < scrollWidth - clientWidth - 10; // 10是误差范围
    },
    handleSlide(direction) {
      const container = document.getElementById(`cultural${this.showNumber}`);
      if(!container) return;
      
      // 获取屏幕类型对应的参数
      const { itemWidth, itemsPerStep } = this.getSlideParams();
      
      const currentScroll = container.scrollLeft;
      const maxScroll = container.scrollWidth - container.clientWidth;
      let targetScroll;

      if(direction === 'left') {
        // 向左滑动（向右滚动）
        targetScroll = Math.max(0, currentScroll - itemWidth * itemsPerStep);
      } else {
        // 向右滑动（向左滚动）
        targetScroll = Math.min(maxScroll, currentScroll + itemWidth * itemsPerStep);
      }

      // 执行滚动
      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    },
    getSlideParams() {
      // 根据屏幕类型返回不同的参数
      if(this.isIndex) {
        // 移动端
        return {
          itemWidth: 192, // 每个项目宽度+边距
          itemsPerStep: 2 // 每次滚动项目数量
        };
      } else {
        // PC端
        return {
          itemWidth: 332, // 每个项目宽度+边距
          itemsPerStep: 4 // 每次滚动项目数量
        };
      }
    },
    toLeft() {
      if (!this.toLeftFlag) return;
      this.handleSlide('left');
    },
    toRight() {
      if (!this.toRightFlag) return;
      this.handleSlide('right');
    },
    toWapLeft() {
      if (!this.toLeftFlag) return;
      this.handleSlide('left');
    },
    toWapRight() {
      if (!this.toRightFlag) return;
      this.handleSlide('right');
    },
    handleMediaQueryChange(event) {
      let screenWidth =
        window.innerWidth || document.documentElement.clientWidth;
      if (event.matches) {
        this.isIndex = false;
        this.screenWidth = Number(screenWidth);
      } else {
        this.isIndex = true;
        this.screenWidth = Number(screenWidth);
      }
      // 更新按钮状态
      this.$nextTick(() => {
        this.updateScrollButtons();
      });
    }
  },
};
</script>

<style scoped>
.cultural-content {
  margin-top: 50px;
  width: 100%;
}
.content-title {
  width: 98%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.title-right-btn {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: Regular;
  padding-right: 15px;
  cursor: pointer;
  margin-bottom: 20px;
}
.act-list {
  position: relative;
  background: #eaeaea;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 32px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin: 10px 0 20px;
}
.carousel {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cultural-content-info {
  width: 100%;
  height: 416px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto; /* 允许水平滚动 */
  scrollbar-width: none; /* 隐藏滚动条（可选，但注意浏览器兼容性） */
}

.cultural-content-info::-webkit-scrollbar {
  display: none;
}

.cultural-item {
  min-width: 324px;
  height: 410px;
  margin-right: 48px;
}
.cultural-item:last-child {
  margin-right: 0;
}

.cultural-item img {
  min-width: 324px;
  height: 324px;
  object-fit: cover;
}
.cultural-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin-top: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* 弹性盒模型 */
  -webkit-box-orient: vertical; /* 元素垂直居中*/
  -webkit-line-clamp: 2; /*  文字显示的行数*/
}
.cultural-money {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  margin-top: 5px;
}
.rightArr {
  width: 32px;
  height: 20px;
}
.leftArr {
  width: 32px;
  height: 20px;
  transform: rotate(180deg);
}
@media (max-width: 1440px) {
  .cultural-content {
    margin-top: 50px;
    width: 100%;
  }
  .content-title {
    width: 95%;
    margin: 0 auto;
  }
  .cultural-item {
    min-width: 264px;
    width: 264px;

    height: 360px;
    margin-right: 28px;
  }
  .cultural-item:last-child {
    margin-right: 0;
  }

  .cultural-item img {
    min-width: 264px;
    width: 264px;
    height: 264px;
    object-fit: cover;
  }
  .cultural-content-info {
    width: 95%;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto; /* 允许水平滚动 */
    scrollbar-width: none; /* 隐藏滚动条（可选，但注意浏览器兼容性） */
  }
}
@media (max-width: 960px) {
  .cultural-content {
    margin-top: 20px;
  }
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .content-title {
    width: 98%;
    margin: 5px 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin: 0;
  }
  .rightArr {
    width: 26px;
    height: 15px;
  }
  .leftArr {
    width: 26px;
    height: 15px;
    transform: rotate(180deg);
  }
  .title-right-btn {
    position: relative;
    color: #98989f;
    text-align: left;
    padding-right: 5px;
    cursor: pointer;
    margin: 0;
  }
  .cultural-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; /* 弹性盒模型 */
    -webkit-box-orient: vertical; /* 元素垂直居中*/
    -webkit-line-clamp: 2; /*  文字显示的行数*/
  }
  .cultural-money {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin-top: 5px;
  }
  .cultural-content-info {
    width: 100%;
    height: 235px;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto; /* 允许水平滚动 */
    scrollbar-width: none; /* 隐藏滚动条（可选，但注意浏览器兼容性） */
  }

  .cultural-content-info::-webkit-scrollbar {
    display: none;
  }

  .cultural-item {
    min-width: 162px;
    height: 230px;
    margin-right: 20px;
  }
  .cultural-item:last-child {
    margin-right: 0;
  }

  .cultural-item img {
    min-width: 162px;
    width: 162px;
    height: 162px;
    object-fit: cover;
  }
}
</style>
